/*
 * Copyright (c) Outright Mental (https://outrightmental.com/) All Rights Reserved.
 */

// vendor
import React from "react";
// app
import "./DashQuantity.scss"

/**
 DashQuantity component renders the given quantity in specified style and adornment.
 <p>
 @return {*}
 @param {{
  color
  backgroundColor
  quantity
  unit
  name
  size
 }} props for this component
 */
export default function DashQuantity(props) {
  const
    color = 'color' in props ? props.color : '#ffffff',
    backgroundColor = props.backgroundColor,
    quantity = props.quantity,
    unit = props.unit,
    name = props.name,
    size = props.size;

  return (
    <div className="dash-quantity" style={{color, backgroundColor}}>
      <div className="name" style={{fontSize: `${size * 12}pt`}}>{name}</div>
      <div className="quantity" style={{fontSize: `${size * 16}pt`}}>{quantity}</div>
      <div className="unit" style={{fontSize: `${size * 10}pt`}}>{unit}</div>
    </div>
  );
};
